import React from "react";
import { HelpCircle } from "lucide-react";

export default function SupportToast(props) {
    const [hovered, setHovered] = React.useState(false);

    const lastPathSegment = React.useMemo(() => {
        if (typeof window === "undefined") return "General";
        const path = window.location.pathname;
        const parts = path.split("/").filter(Boolean);
        return parts.length > 0 ? parts[parts.length - 1] : "Home";
    }, []);

    const mailSubject = encodeURIComponent(`Help with ${lastPathSegment.replace(/[-_]/g, " ").replace(/\b\w/g, c => c.toUpperCase())}`);

    return <div className={`flex justify-center pb-6 pt-24 ${props?.className || ""}`}>
        <a
            href={`mailto:support@sparklingemail.com?subject=${mailSubject}`}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            <div className="relative px-4 py-2 rounded-lg bg-white/80 backdrop-blur-sm shadow-md border border-slate-200 flex items-center gap-2 overflow-hidden hover:cursor-pointer">

                {hovered && (
                    <div className="absolute inset-0 pointer-events-none animate-once-gradient" />
                )}

                <div className="relative group-hover:animate-[wiggle_0.4s_ease-in-out]">
                    <HelpCircle className="w-4 h-4 text-blue-600" />
                </div>

                <p className="text-xs text-slate-600 relative">
                    Need help? Let us know at{" "}
                    <span className="font-semibold text-slate-700">
                        support@sparklingemail.com
                    </span>
                </p>
            </div>
        </a>
    </div>
}
